var _path, _line, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDockerfileMissingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7311 13.4788H13.0825V11.8753H14.7311V13.4788ZM14.7311 8H13.0825V9.63029H14.7311V8ZM16.7045 11.8753H15.0558V13.4788H16.7045V11.8753ZM12.7827 9.951H11.1341V11.5546H12.7827V9.951ZM14.7311 9.951H13.0825V11.5546H14.7311V9.951ZM21.6503 12.6236C21.3006 12.3563 20.4763 12.2762 19.8268 12.4098C19.7519 11.7684 19.4022 11.2071 18.8027 10.6993L18.453 10.4588L18.2282 10.833C17.7536 11.5813 17.6287 12.784 18.1283 13.6125C17.9034 13.7194 17.4788 13.9065 16.9293 13.8797H6.06339C5.83858 15.2428 6.21327 17.0067 7.16247 18.2094C8.08669 19.3853 9.48552 20 11.284 20C15.2307 20 18.1283 18.049 19.5021 14.5212C20.0267 14.5479 21.1757 14.5212 21.7752 13.3185C21.8251 13.265 21.95 12.971 22 12.8641L21.6503 12.6236ZM8.88602 11.8753H7.23741V13.4788H8.88602V11.8753ZM10.8344 11.8753H9.18577V13.4788H10.8344V11.8753ZM12.7827 11.8753H11.1341V13.4788H12.7827V11.8753ZM10.8344 9.951H9.18577V11.5546H10.8344V9.951Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.64645,
    y1: 23.6464,
    x2: 23.6464,
    y2: 4.64645,
    stroke: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockerfileMissingIcon);
export default __webpack_public_path__ + "static/media/dockerfile-missing-icon.5909640cd68e1bdb3c381d30306f703d.svg";
export { ForwardRef as ReactComponent };